import { slice } from './slice';

const { reducer } = slice;

export * from './thunks';
export * from './actions';
export * as streamsSelectors from './selectors';

export default reducer;
